module.exports = __webpack_public_path__ + "static/media/logo.23ee20db.png";